import _ from "lodash";
import { HotCell } from "~app/common/components/hot-doc/hotdoc/cell";

export class SummaryCell extends HotCell {
    value: number;

    constructor(rawvalue: number) {

        super();
        this.value = Math.round(rawvalue);
    }

    static format(value: number): string {
        const val = _.isNumber(value) ? Math.round(value) : 0;
        return `${val.toLocaleString("en").replace(/,/g, " ")}`;
    }

    validate(value: any): boolean {
        return _.isNumber(value) || !isNaN(value);
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return SummaryCell.format(this.value);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        td.classList.add(HotCell.hotNumber);
        td.classList.add("hot-readonly");
        cellProperties.readOnly = true;
    }
}
